import { isFeatureSettingEnabled } from 'client/admin/core/feature-settings';
import { LoadedAdminData } from 'client/admin/shared/types';
import { getConfig } from 'client/shared/core/config';
import { AiAssistant, AiAssistantName, FeatureSettingType, isEnum } from 'core';

export const assistantLabelByName: Record<AiAssistantName, string> = {
  [AiAssistantName.POLLY]: 'Polly, Polco Assistant',
  [AiAssistantName.GRANT_WRITER]: 'Grace, Grant Writing Assistant',
  [AiAssistantName.ANNIE]: 'Annie, Internal Assistant',
  [AiAssistantName.SANDBOX]: 'Sandbox, Custom AI Assistant',
};

export function getAssistantName(assistantName: string): string {
  if (isEnum(AiAssistantName, assistantName)) {
    return assistantLabelByName[assistantName];
  }
  return assistantName;
}

export enum AiAssistantDisableReason {
  EXPIRED_SESSION = 'EXPIRED_SESSION',
  QUERY_LIMIT_REACHED = 'QUERY_LIMIT_REACHED',
  NOT_FOUND_SESSION = 'NOT_FOUND_SESSION',
}

// This might eventually make more sense as a hook that internally queries the data it needs.
// We'll see as the components evolve in future refactoring.
export function aiAssistantAvailability(
  assistant: AiAssistant,
  loadedAdminData: LoadedAdminData,
  ignoreFeatureSettings: boolean
) {
  const config = getConfig();
  if (
    (assistant.id === AiAssistantName.ANNIE ||
      assistant.id === AiAssistantName.SANDBOX) &&
    !loadedAdminData.admin.superAdmin
  ) {
    return 'FORBIDDEN';
  } else if (
    assistant.id === AiAssistantName.POLLY ||
    assistant.id === AiAssistantName.GRANT_WRITER
  ) {
    const featureSettingType =
      assistant.id === AiAssistantName.POLLY
        ? FeatureSettingType.AI_ASSISTANT
        : FeatureSettingType.GRANT_WRITER_ASSISTANT;
    const freeQuestionLimit =
      assistant.id === AiAssistantName.POLLY
        ? config.envFeatures.pollyFreeQuestionLimit
        : config.envFeatures.grantWriterFreeQuestionLimit;
    const aiAssistantEnabled =
      ignoreFeatureSettings ||
      freeQuestionLimit > 0 ||
      isFeatureSettingEnabled(
        loadedAdminData.admin.activePublishingEntity.featureSettings,
        featureSettingType
      );
    if (!aiAssistantEnabled) {
      return 'DISABLED';
    }
  } else if (assistant.type === 'PubAssistant') {
    // No requirements currently
  }

  return 'ENABLED';
}
